import { TFunction } from 'react-i18next';
import { ColumnsType } from 'antd/es/table';
import { IFilter } from '@/models/filters.model';
import { StyledBadge } from '@/components';
import FilterTableActions from '../../components/FilterTableActions/FilterTableActions';
import { getFilterCategoriesRow, getFilterValuesRow } from '../../helpers/selectors';

type TGetPartnersTableColumns = {
  t: TFunction;
  canManage: boolean;
  onEdit: (filter: IFilter) => void;
  onDelete: (filter: IFilter) => void;
};

export const getFiltersTableColumns = ({
  t,
  canManage,
  onEdit,
  onDelete,
}: TGetPartnersTableColumns): ColumnsType<IFilter> => [
  {
    title: t('filter_position_column_title'),
    dataIndex: 'position',
    key: 'position',
    render: (position) => <span>{position}</span>,
  },
  {
    title: t('filter_name_column_title'),
    dataIndex: 'title',
    key: 'title',
    render: (_, record) => <span>{record.locale?.uk?.title ?? '—'}</span>,
  },
  {
    title: t('filter_type_column_title'),
    dataIndex: 'type',
    key: 'type',
    render: (type) => <span>{t(`filters_${type}`)}</span>,
  },
  {
    title: t('filter_value_column_title'),
    dataIndex: 'values',
    key: 'values',
    render: (_, record) => {
      return <span>{getFilterValuesRow(record)}</span>;
    },
  },
  {
    title: t('filter_category_column_title'),
    dataIndex: 'categories',
    key: 'categories',
    render: (_, record) => <span>{getFilterCategoriesRow(record)}</span>,
  },
  {
    title: t('filter_visibility_column_title'),
    dataIndex: 'is_active',
    key: 'is_active',
    render: (is_active) => (
      <StyledBadge $isActive={is_active}>{is_active ? t('filter_visible') : t('filter_non_visible')}</StyledBadge>
    ),
  },
  {
    title: t('filter_required_column_title'),
    dataIndex: 'required',
    key: 'required',
    render: (required) => (
      <StyledBadge $isActive={required}>{required ? t('filter_yes_title') : t('filter_non_title')}</StyledBadge>
    ),
  },
  {
    title: t('filter_shown'),
    dataIndex: 'filterable',
    key: 'filterable',
    render: (filterable) => (
      <StyledBadge $isActive={filterable}>{filterable ? t('filter_yes_title') : t('filter_non_title')}</StyledBadge>
    ),
  },
  {
    title: t('filter_actions_column_title'),
    key: 'actions',
    render: (_, record) => {
      return <FilterTableActions record={record} canManage={canManage} onEdit={onEdit} onDelete={onDelete} />;
    },
  },
];
